import React from "react";
import { Link } from "react-router-dom";
import * as procService from "../../services/procService";
import { DataTable, StatTile, TileGrid } from "./procUi";
import { EmptyState, LoadState, PageHeader, formatDate, pageStyle, useLoad } from "../../components/ui";

// Procurement at a glance (buyer): what needs a decision or an action, with a link to each list.
const alert = (n) => (n ? "#92400E" : "#111827");

export default function Dashboard() {
  const { data: d, loading, error, reload } = useLoad(() => procService.getDashboard(), []);
  return (
    <div style={pageStyle}>
      <PageHeader title="Procurement" subtitle="What needs your attention" />
      <LoadState loading={loading} error={error} onRetry={reload}>
        {d ? (
          <>
            <TileGrid>
              <StatTile label="Live RFQs" value={d.rfqs.live} to="/proc/rfqs" note={d.rfqs.closing_soon ? `${d.rfqs.closing_soon} closing soon` : "None closing soon"} tone={d.rfqs.closing_soon ? "#92400E" : "#111827"} />
              <StatTile label="Quotations to review" value={d.quotations_to_review} to="/proc/rfqs" tone={alert(d.quotations_to_review)} note="On live or evaluating RFQs" />
              <StatTile label="Awards waiting for approval" value={d.awards.pending_approval} to="/proc/awards" tone={alert(d.awards.pending_approval)} note={d.awards.draft ? `${d.awards.draft} draft` : undefined} />
              <StatTile label="Orders waiting for the supplier" value={d.orders.waiting_for_supplier} to="/proc/orders" tone={alert(d.orders.waiting_for_supplier)} />
              <StatTile label="Orders on their way" value={d.orders.in_progress} to="/proc/orders" />
              <StatTile label="Delivered: to complete" value={d.orders.delivered} to="/proc/orders" tone={alert(d.orders.delivered)} />
              <StatTile label="Invoices without a bill" value={d.invoices_without_bill} to="/proc/orders" tone={alert(d.invoices_without_bill)} note="Bill is drafted once goods are received" />
              <StatTile label="Unread messages" value={d.unread_messages} to="/proc/messages" tone={alert(d.unread_messages)} />
              <StatTile label="Active suppliers" value={d.suppliers.active} to="/proc/suppliers" note={d.suppliers.invited ? `${d.suppliers.invited} invited, not yet joined` : undefined} />
            </TileGrid>

            <h6>RFQs closing soon</h6>
            <DataTable
              minWidth={460}
              rowKey={(r) => r.rfq_number}
              rows={d.closing_soon}
              empty={<EmptyState title="No RFQ closes in the next two days" />}
              columns={[
                { label: "RFQ", render: (r) => <Link to={`/proc/rfqs/${r.id}`}><strong>{r.title}</strong> <span style={{ color: "#6B7280" }}>{r.rfq_number}</span></Link> },
                { label: "Closes", render: (r) => formatDate(r.responsible_date) },
                { label: "Quotations so far", render: (r) => r.quotation_count },
              ]}
            />
            <h6 className="mt-4">Delivered orders to complete</h6>
            <DataTable
              minWidth={380}
              rowKey={(r) => r.order_number}
              rows={d.to_complete}
              empty={<EmptyState title="Nothing waiting to be completed" />}
              columns={[
                { label: "Order", render: (r) => <Link to={`/proc/orders/${r.id}`}><strong>{r.order_number}</strong></Link> },
                { label: "Supplier", render: (r) => r.company_name },
              ]}
            />
          </>
        ) : null}
      </LoadState>
    </div>
  );
}
